import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';

@Component({
  selector: 'app-stage-upload',
  templateUrl: './stage-upload.component.html',
  styleUrls: ['./stage-upload.component.css']
})
export class StageUploadComponent implements OnInit {

  movieId: any;
  stageName: any;
  image: any;
  admin = false;
  details: any;
  title: any;
  url: any;
  updatedImage: any;
  order: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
     private hitmakerservice: HitmakerService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public auth: AuthenticationService,) {

  }

  uploadStage = this.formBuilder.group({
    videoUrl: [''],
    mainTitle: [''],
    thumbnailImage: [''],
    sequence: [''],
  });

  ngOnInit(): void {
    this.auth.checkUserAuthenticated().subscribe((data: any) => {
      var role = data.adminRole
      if (!role) {
        this.admin = false
      }
      else {
        this.admin = true
      }
    })

    this.movieId = this.activatedRoute.snapshot.params['id'];
    this.stageName = this.activatedRoute.snapshot.params['stage-name'];
    
    this.uploadStage = this.formBuilder.group({
      videoUrl: ['', [Validators.required]],
      mainTitle: ['', Validators.required],
      thumbnailImage: [null, Validators.required],
      sequence: [null, [Validators.required, Validators.min(1)]],
    });
  }

  postHitmakerVideo() {

    if (this.uploadStage.invalid) {
      alert("Please enter all required values.");
      return;
    }

    const data = {
      url: this.uploadStage.get('videoUrl').value,
      title: this.uploadStage.get('mainTitle').value,
      order: this.uploadStage.get('sequence').value,
    };

    const formData = new FormData();

    if (this.image !== null) {
      formData.set('thumbnailImage', this.image);
    }

    this.spinner.show();
    this.hitmakerservice.postHitmakerUploadVideo(this.movieId, this.stageName, data, formData)
      .subscribe(response => {
        if (response) {
          this.spinner.hide();
          alert("Uploaded Successfully!!");
          this.router.navigate(['/hitmaker/' + this.movieId + '/stage/' + this.stageName]);
        } else {
          alert("Please Upload a valid url.");
        }
      },
      (error) => {
        this.spinner.hide();
        alert("Please Upload a valid url.");
        }
      );
  }

  onFileSelected(file: File): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.updatedImage = reader.result;
      const eventImgControl = this.uploadStage.get(`thumbnailImage`);
      eventImgControl.setValue(reader.result);
    };
    this.image = file;
  }

}